import { initializeApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendEmailVerification, sendPasswordResetEmail, signOut, confirmPasswordReset, verifyPasswordResetCode } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyA6SSPpFE6c9hF2gKdOwemmFV8yS3oCdyQ",
  authDomain: "rydrlink.firebaseapp.com",
  projectId: "rydrlink",
  storageBucket: "rydrlink.firebasestorage.app",
  messagingSenderId: "139543432794",
  appId: "1:139543432794:web:c0d22a7537762fcd62d263",
  measurementId: "G-ZYKK0CTV5D"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendEmailVerification, sendPasswordResetEmail, signOut, confirmPasswordReset, verifyPasswordResetCode };
